export default __webpack_public_path__ + "static/media/6.336dd7f1.png";